import styles from "./SurveyLayout.module.scss";

import { Outlet } from "@tanstack/react-router";

export function SurveyLayout() {
  return (
    <div className={styles.layout}>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
